export default "__VITE_ASSET__e37e93d6__"